module.exports = __webpack_public_path__ + "static/media/säl-min.89999459.png";